import React from 'react';
import { connect } from 'react-redux';
import RoundedModal from 'components/Global/RoundedModal/RoundedModal.jsx';
import { getSubscriptions, fetchSettingsBrands, fetchSettingsPublishers } from 'components/Pages/Settings/actions.js';
import EntityPicker from 'components/Global/EntityPicker/EntityPicker.jsx';
import { createBulkSubscriptions } from './actions.js';

class AddSubscriptionsModal extends React.Component {
  componentDidMount() {
    this.props.getSubscriptions(true);
  }

  handleSubmit(newSubscriptions) {
    const { submit, submitCallback, close } = this.props;
    submit(newSubscriptions);

    if (submitCallback) {
      submitCallback();
    }

    close();
  }

  render() {
    const { getBrands, getPublishers, close, isOpen, subscriptionsList } = this.props;
    const subscriptions = subscriptionsList.data.map(entity => entity.public_id);

    return (
      <RoundedModal close={close} isOpen={isOpen}>
        <EntityPicker
          brandFetch={getBrands}
          publisherFetch={getPublishers}
          multiple
          title="Add subscriptions"
          submit={newSubscriptions => this.handleSubmit(newSubscriptions)}
          excludedIds={subscriptions}
        />
      </RoundedModal>
    );
  }
}

const mapStateToProps = ({
  Settings: { subscriptionsList },
  Account: { userEntity },
}) => ({
  subscriptionsList, userEntity,
});

const mapDispatchToProps = (dispatch) => ({
  getBrands: (clear) => dispatch(fetchSettingsBrands(clear)),
  getPublishers: (clear) => dispatch(fetchSettingsPublishers(clear)),
  getSubscriptions: (clear) => dispatch(getSubscriptions(clear)),
  submit: newSubscriptions => dispatch(createBulkSubscriptions(newSubscriptions)),
});


export default connect(mapStateToProps, mapDispatchToProps)(AddSubscriptionsModal);
